import React, { useState, useEffect } from "react";
import { Form, Input, Row, Col, Select, message, Spin } from "antd";
import fetchAccount from "@/core/account/fetchAccount";
import updateAccount from "@/core/account/updateAccount";
import helpers from "@/helpers/helpers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const AccountUpdate = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const session = useSelector(e => e?.session);

    const get = () => {
        setLoading(true);
        fetchAccount()
            .then((res) => {
                const data = res.data.data;
                form.setFieldsValue(data);
            })
            .catch(() => {
                message.error(t("error-fetch-profile"));
            })
            .finally(() => setLoading(false));
    };

    const update = () => {
        setLoading(true);
        const data = helpers.cleanObj(form.getFieldsValue());
        updateAccount(data)
            .then(() => {
                message.success(t("success-profile-updated"));
            })
            .catch(() => {
                message.error(t("error-profile-update"));
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        get();
    }, [session?.relationId]);

    return (
        <Spin tip={t("loading")} spinning={loading}>
            <Form layout="vertical" onFinish={update} form={form}>
                <Row gutter={16}>
                    <Col lg={12}>
                        <Form.Item
                            label={t("name")}
                            name="Name"
                            rules={[{ required: true, message: t("required-name") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col lg={12}>
                        <Form.Item
                            label={t("first-name")}
                            name="FirstName"
                            rules={[{ required: true, message: t("required-first-name") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col lg={12}>
                        <Form.Item
                            label={t("email")}
                            name="Email"
                            rules={[{ required: true, message: t("required-email") }]}
                        >
                            <Input type="email" placeholder={t("placeholder-email")} />
                        </Form.Item>
                    </Col>

                    <Col lg={12}>
                        <Form.Item
                            label={t("phone")}
                            name="Phone"
                            rules={[{ required: true, message: t("required-phone") }]}
                        >
                            <Input placeholder={t("placeholder-phone")} />
                        </Form.Item>
                    </Col>

                    <Col lg={12}>
                        <Form.Item
                            label={t("password")}
                            name="Password"
                        >
                            <Input type="password" placeholder={t("placeholder-password")} />
                        </Form.Item>
                    </Col>

                    <Col lg={12}>
                        <Form.Item
                            label={t("language")}
                            name="Language"
                            rules={[{ required: true, message: t("required-language") }]}
                        >
                            <Select>
                                <Select.Option value="NL">NL</Select.Option>
                                <Select.Option value="TR">TR</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col lg={24}>
                        <Form.Item
                            label={t("address")}
                            name="Address"
                            rules={[{ required: true, message: t("required-address") }]}
                        >
                            <Input.TextArea />
                        </Form.Item>
                    </Col>

                    <Col lg={8}>
                        <Form.Item
                            label={t("city")}
                            name="City"
                            rules={[{ required: true, message: t("required-city") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col lg={8}>
                        <Form.Item
                            label={t("country")}
                            name="Country"
                            rules={[{ required: true, message: t("required-country") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col lg={8}>
                        <Form.Item
                            label={t("postal-code")}
                            name="PostalCode"
                            rules={[{ required: true, message: t("required-postal-code") }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col lg={24}>
                        <div className="flex items-center justify-center">
                            <button className="mega-button">{t("update")}</button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
};

export default AccountUpdate;
